import { SVGProps } from "react"

const GiftCardSymbolIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79"
      height="80"
      viewBox="0 0 79 80"
      fill="none"
      {...props}
    >
      <path
        d="M59.6566 -11.4242L52.8443 -4.61185L24.042 24.1904L27.1619 27.3103L55.9641 -1.49198L59.834 -5.36186L62.7764 -8.3043C62.8928 -8.42066 63.0472 -8.39992 63.1428 -8.31351L60.0229 -11.4334C59.9273 -11.5198 59.7729 -11.5405 59.6566 -11.4242Z"
        fill="url(#paint0_linear_20157_34341)"
      />
      <path
        d="M-11.572 59.8039L-4.75966 52.9916L24.0426 24.1893L27.1625 27.3092L-1.6398 56.1115L-5.50967 59.9813L-8.45211 62.9238C-8.56847 63.0401 -8.54774 63.1945 -8.46133 63.2901L-11.5812 60.1703C-11.6676 60.0746 -11.6883 59.9203 -11.572 59.8039Z"
        fill="url(#paint1_linear_20157_34341)"
      />
      <path
        d="M31.5842 23.2621C29.8411 24.3416 28.1659 25.1849 27.5277 25.579C27.5404 25.5594 27.606 25.4453 27.7258 25.2541C28.6648 23.7275 32.7536 17.3899 35.8942 17.2148C36.2294 17.1952 36.4287 17.2516 36.5163 17.3668C36.6315 17.4544 36.688 17.6537 36.6684 17.989C36.5658 19.8127 34.0082 21.7644 31.5842 23.2621Z"
        fill="url(#paint2_linear_20157_34341)"
      />
      <path
        d="M27.5284 25.579C28.1667 25.185 29.8418 24.3417 31.5849 23.2622C35.4928 23.7276 40.1761 26.1597 40.1761 26.1597L36.5977 28.215L37.9272 31.6044C32.4444 30.9189 26.7047 26.859 26.7047 26.859C27.3326 26.2311 27.5261 25.5813 27.5261 25.5813L27.5284 25.579Z"
        fill="url(#paint3_linear_20157_34341)"
      />
      <path
        d="M27.5275 25.5788C27.5241 25.5154 27.4734 24.7251 26.842 24.0408C26.1853 23.3265 25.2326 23.1709 25.2326 23.1709C23.2579 17.3805 28.9135 8.51979 32.0668 12.1316L36.5231 17.3598L36.5161 17.3667C36.4286 17.2515 36.2293 17.195 35.894 17.2146C32.7546 17.3909 28.6658 23.7285 27.7257 25.2539C27.6059 25.4452 27.539 25.5604 27.5275 25.5788Z"
        fill="url(#paint4_linear_20157_34341)"
      />
      <path
        d="M25.231 23.1703C25.231 23.1703 24.9914 23.2049 24.0213 24.175C23.0513 25.145 23.0167 25.3847 23.0167 25.3847C23.0167 25.3847 23.1734 26.3363 23.8865 26.9941C24.5709 27.6255 25.3624 27.675 25.4246 27.6796C25.4246 27.6796 26.0744 27.4861 26.7022 26.8582C27.3301 26.2303 27.5237 25.5805 27.5237 25.5805C27.5191 25.516 27.4684 24.7257 26.837 24.0413C26.1803 23.327 25.2276 23.1715 25.2276 23.1715L25.231 23.1703Z"
        fill="url(#paint5_linear_20157_34341)"
      />
      <path
        d="M23.1097 31.7371C24.1892 29.9939 25.0326 28.3188 25.4266 27.6805C25.407 27.6932 25.2929 27.7589 25.1017 27.8787C23.5752 28.8177 17.2375 32.9064 17.0624 36.047C17.0428 36.3823 17.0993 36.5816 17.2145 36.6691C17.302 36.7844 17.5014 36.8408 17.8366 36.8212C19.6604 36.7187 21.612 34.1611 23.1097 31.7371Z"
        fill="url(#paint6_linear_20157_34341)"
      />
      <path
        d="M25.4271 27.6789C25.033 28.3172 24.1897 29.9923 23.1102 31.7354C23.5756 35.6433 26.0077 40.3266 26.0077 40.3266L28.063 36.7482L31.4525 38.0777C30.767 32.5949 26.707 26.8552 26.707 26.8552C26.0791 27.483 25.4294 27.6766 25.4294 27.6766L25.4271 27.6789Z"
        fill="url(#paint7_linear_20157_34341)"
      />
      <path
        d="M25.4265 27.6789C25.3631 27.6754 24.5728 27.6248 23.8884 26.9934C23.1741 26.3367 23.0186 25.3839 23.0186 25.3839C17.2282 23.4093 8.36744 29.0649 11.9792 32.2181L17.2074 36.6744L17.2143 36.6675C17.0991 36.5799 17.0427 36.3806 17.0623 36.0454C17.2385 32.9059 23.5762 28.8172 25.1016 27.8771C25.2928 27.7572 25.408 27.6904 25.4265 27.6789Z"
        fill="url(#paint8_linear_20157_34341)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20157_34341"
          x1="27.5"
          y1="24"
          x2="57.5"
          y2="-7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00165B" />
          <stop offset="0.65" stop-color="#024C9D" />
          <stop offset="0.77" stop-color="#058DEE" />
          <stop offset="1" stop-color="#0024AB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_20157_34341"
          x1="24.6578"
          y1="26.8714"
          x2="-9.48439"
          y2="61.0136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00165B" />
          <stop offset="0.65" stop-color="#024C9D" />
          <stop offset="0.77" stop-color="#058DEE" />
          <stop offset="1" stop-color="#0024AB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_20157_34341"
          x1="27.8139"
          y1="25.8665"
          x2="36.4177"
          y2="17.2626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#03377C" />
          <stop offset="1" stop-color="#022D6D" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_20157_34341"
          x1="30.0169"
          y1="23.0905"
          x2="38.229"
          y2="31.3026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00165B" />
          <stop offset="0.65" stop-color="#024C9D" />
          <stop offset="0.77" stop-color="#058DEE" />
          <stop offset="1" stop-color="#00165B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_20157_34341"
          x1="39"
          y1="5"
          x2="25.5"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0024AB" />
          <stop offset="0.405407" stop-color="#0024AB" />
          <stop offset="0.637236" stop-color="#058DEE" />
          <stop offset="1" stop-color="#00165B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_20157_34341"
          x1="21.5"
          y1="21"
          x2="27"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0024AB" />
          <stop offset="0.526976" stop-color="#0024AB" />
          <stop offset="0.843293" stop-color="#058DEE" />
          <stop offset="1" stop-color="#00165B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_20157_34341"
          x1="17.1108"
          y1="36.5701"
          x2="25.7146"
          y2="27.9663"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#013582" />
          <stop offset="1" stop-color="#03377C" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_20157_34341"
          x1="22.9339"
          y1="30.172"
          x2="31.146"
          y2="38.3841"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00165B" />
          <stop offset="0.65" stop-color="#024C9D" />
          <stop offset="0.77" stop-color="#058DEE" />
          <stop offset="1" stop-color="#00165B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_20157_34341"
          x1="7"
          y1="40.1928"
          x2="23.5"
          y2="25.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0024AB" />
          <stop offset="0.421713" stop-color="#0024AB" />
          <stop offset="0.77" stop-color="#058DEE" />
          <stop offset="1" stop-color="#00165B" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GiftCardSymbolIcon
